// extracted by mini-css-extract-plugin
module.exports = {"section03":"Section3New_section03___mS8f"};